var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28438 0.359375L5.31563 1.39062L2.56563 4.14062L2.05 4.57031L1.53438 4.14062L0.159375 2.76562L1.19063 1.73438L2.05 2.63672L4.28438 0.359375ZM7.55 1.5625H16.4875V2.9375H7.55V1.5625ZM4.28438 5.85938L5.31563 6.89062L2.56563 9.64062L2.05 10.0703L1.53438 9.64062L0.159375 8.26562L1.19063 7.23438L2.05 8.13672L4.28438 5.85938ZM7.55 7.0625H16.4875V8.4375H7.55V7.0625ZM4.28438 11.3594L5.31563 12.3906L2.56563 15.1406L2.05 15.5703L1.53438 15.1406L0.159375 13.7656L1.19063 12.7344L2.05 13.6367L4.28438 11.3594ZM7.55 12.5625H16.4875V13.9375H7.55V12.5625Z",
    fill: "#202224"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.cebb85073d4e2c8a7ad6397c07e46396.svg";
export { ForwardRef as ReactComponent };